<template>
  <div class="quarks-pro-fixed">
    <div class="viz-header-compact" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula-chip" v-latex>$Q = 2/3e or -1/3e$</div>
    </div>

    <div class="main-layout vertical">
      <div class="simulation-stage dark-stage">
        <div class="hud-panel">
          <div class="hud-item cyan">
            <label>当前粒子</label>
            <span class="val">{{ activeQuark.name }} ({{ activeQuark.symbol }})</span>
          </div>
          <div class="hud-item orange">
            <label>电荷 (Charge)</label>
            <span class="val">{{ activeQuark.charge }} e</span>
          </div>
          <div class="hud-item green">
             <label>质量 (Mass)</label>
             <span class="val">{{ activeQuark.mass }} <small>MeV</small></span>
          </div>
        </div>

        <svg width="100%" height="240" viewBox="0 0 450 240" preserveAspectRatio="xMidYMid meet">
          <!-- 背景粒子云 (Sub-atomic Cloud) -->
          <circle cx="225" cy="120" r="80" fill="rgba(88, 28, 135, 0.1)" stroke="rgba(139, 92, 246, 0.2)" stroke-dasharray="5,5" />
          
          <!-- 动态夸克主体 (Quark Entity) -->
          <g :transform="`translate(${225 + Math.sin(time)*5}, ${120 + Math.cos(time)*5})`">
             <circle r="30" :fill="activeQuark.color" filter="url(#glow-q)" />
             <text text-anchor="middle" y="8" fill="white" font-size="24" font-weight="900">{{ activeQuark.symbol }}</text>
             
             <!-- 色荷环绕 (Color Charge Indicators) -->
             <circle v-for="i in 3" :key="i" 
                     :cx="Math.cos(time + i*2.1)*40" 
                     :cy="Math.sin(time + i*2.1)*40" 
                     r="4" :fill="['#ef4444','#22c55e','#3b82f6'][i-1]" />
          </g>

          <defs>
             <filter id="glow-q"><feGaussianBlur stdDeviation="6" result="blur"/><feComposite in="SourceGraphic" in2="blur" operator="over"/></filter>
          </defs>
        </svg>

        <div class="physics-caption">
           规律：夸克是构成强子（如质子、中子）的更基本单元。它们携带分立电荷，并通过强相互作用（胶子交换）紧密黏合。
        </div>
      </div>

      <div class="compact-controls">
        <div class="control-card">
           <div class="btn-grid-quarks">
              <el-button v-for="q in quarkTypes" :key="q.id" 
                size="mini" 
                :type="activeQuark.id === q.id ? 'primary' : 'info'" 
                plain
                @click="activeQuark = q">
                {{ q.name }} ({{ q.symbol }})
              </el-button>
           </div>
        </div>
        
        <!-- 高对比度蓝色专业卡片加固 -->
        <div class="discovery-card-discovery-tir" v-latex>
           <div class="icon-wrap"><i class="el-icon-aim"></i></div>
           <div class="text-content">
             <p><strong>实战物理/粒子加速器：</strong>夸克是人类探索物质最深层的边界。<strong>解惑：</strong>质子里面是什么？<strong>观察：</strong>切换不同的夸克。你会发现诸如**上夸克 (u)** 具有 +2/3 电荷，而**下夸克 (d)** 具有 -1/3。正是这种“不完整”的电荷巧妙组合，构成了我们宏观世界中所有的正常电荷单位。它们永远不会以单体形式存在，这就是著名的**夸克禁闭**。
             </p>
           </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default { props: { knowledgePoint: String },
  name: 'StandardModelQuarksViz',
  data() {
    return {
      time: 0,
      activeQuark: { id: 'u', name: '上夸克', symbol: 'u', charge: '+2/3', mass: '2.2', color: '#3b82f6' },
      quarkTypes: [
        { id: 'u', name: '上夸克', symbol: 'u', charge: '+2/3', mass: '2.2', color: '#3b82f6' },
        { id: 'd', name: '下夸克', symbol: 'd', charge: '-1/3', mass: '4.7', color: '#10b981' },
        { id: 's', name: '奇异夸克', symbol: 's', charge: '-1/3', mass: '95', color: '#a855f7' },
        { id: 'c', name: '粲夸克', symbol: 'c', charge: '+2/3', mass: '1270', color: '#f43f5e' },
        { id: 'b', name: '底夸克', symbol: 'b', charge: '-1/3', mass: '4180', color: '#fbbf24' },
        { id: 't', name: '顶夸克', symbol: 't', charge: '+2/3', mass: '173000', color: '#64748b' }
      ]
    }
  },
  mounted() { this.animate(); },
  methods: {
    animate() {
       this.time += 0.03;
       this.animFrame = requestAnimationFrame(this.animate);
    }
  },
  beforeDestroy() {
    if (this.animFrame) cancelAnimationFrame(this.animFrame);
    if (this.timer) clearInterval(this.timer);
  },
}
</script>

<style scoped lang="scss">
@import "./PhysicsCommon.scss";
.quarks-pro-fixed { flex: 1; display: flex; flex-direction: column; gap: 8px; height: 100%; overflow: hidden; }
.btn-grid-quarks { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; }
</style>
